import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { styled } from '@ori-ui/mui';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { CONSULTANT_NUMBER_QUERY_PARAM_KEY } from '../../constants';
import { useConfigurationContext } from '../../contexts/ConfigurationContext';
import { useSocialMediaContext } from '../../contexts/SocialMediaContext';
import { AccountPanes } from '../../models';
import { ConnectExternalAccount } from './ConnectExternalAccount';
import { ForgotPassword } from './ForgotPassword';
import Login from './Login/Login';
import LoginOrisales from './Login/LoginOrisales';
import { NewPassword } from './NewPassword';
import { NewPasswordSuperUser } from './NewPasswordSuperUser';
import { jsx as _jsx } from "react/jsx-runtime";
var AccountRoot = styled('div')(function () {
  return {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - var(--top-nav-height))',
    width: '100%'
  };
});
export var Account = function Account() {
  var _useState = useState(AccountPanes.LoginPane),
      _useState2 = _slicedToArray(_useState, 2),
      activePane = _useState2[0],
      setActivePane = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      username = _useState4[0],
      setUsername = _useState4[1];

  var _useConfigurationCont = useConfigurationContext(),
      externalLoginName = _useConfigurationCont.externalLoginName,
      isCumulusMarket = _useConfigurationCont.isCumulusMarket;

  var searchParams = new URLSearchParams(window.location.search);
  var consultantNumber = searchParams.get(CONSULTANT_NUMBER_QUERY_PARAM_KEY);

  var _useSocialMediaContex = useSocialMediaContext(),
      fetchSocialMediaConfiguration = _useSocialMediaContex.fetchSocialMediaConfiguration;

  var handlePaneChange = useCallback(function (paneName, user) {
    if (user) {
      setUsername(user);
    }

    setActivePane(paneName);
  }, [setActivePane, setUsername]);
  var Panes = useMemo(function () {
    var _ref;

    return _ref = {}, _defineProperty(_ref, AccountPanes.LoginPane, isCumulusMarket ? Login : LoginOrisales), _defineProperty(_ref, AccountPanes.ForgotPassPane, ForgotPassword), _defineProperty(_ref, AccountPanes.NewPassPane, NewPassword), _defineProperty(_ref, AccountPanes.ConnectExternalAccount, ConnectExternalAccount), _defineProperty(_ref, AccountPanes.NewPassSuperUserPane, NewPasswordSuperUser), _ref;
  }, [isCumulusMarket]);
  var ActivePane = Panes[activePane];
  useEffect(function () {
    fetchSocialMediaConfiguration();
  }, [fetchSocialMediaConfiguration]);
  useEffect(function () {
    if (externalLoginName) {
      handlePaneChange(AccountPanes.ConnectExternalAccount);
    }
  }, [externalLoginName, handlePaneChange]);
  useEffect(function () {
    if (consultantNumber) {
      handlePaneChange(AccountPanes.NewPassPane);
    }
  }, [consultantNumber, handlePaneChange]);
  return /*#__PURE__*/_jsx(AccountRoot, {
    children: /*#__PURE__*/_jsx(ActivePane, {
      goToPane: handlePaneChange,
      username: username
    })
  });
};
export default Account;